/* <sticky-atc> — barre d'achat collante mobile : visible quand le bouton principal est passé au-dessus de l'écran. */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.section = document.getElementById(`MainProduct-${this.sectionId}`);
        this.mainButton = this.section && this.section.querySelector('.product-form__submit');
        if (!this.mainButton || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          const e = entries[0];
          const passedAbove = !e.isIntersecting && e.boundingClientRect.top < 0;
          this.hidden = !passedAbove;
        }, { threshold: 0 });
        this.observer.observe(this.mainButton);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
            const variant = event.data.variant;
            const btn = this.querySelector('.sticky-atc__button');
            if (!variant || !variant.available) {
              btn.setAttribute('disabled', '');
            } else {
              btn.removeAttribute('disabled');
              const price = this.querySelector('[data-sticky-price]');
              if (price) price.textContent = this.formatMoney(variant.price);
              const title = this.querySelector('[data-sticky-variant]');
              if (title) title.textContent = '· ' + variant.title;
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      formatMoney(cents) {
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || this.dataset.currency || 'EUR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + ' ' + currency;
        }
      }
    }
  );
}
